import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { search as searchActions } from 'redux/modules/api'
import { notification } from 'redux/modules/app'
import appConfig from 'config'

function decorator() {
  return ComposedComponent => {
    @connect(({ api }) => ({ search: api.search }), {
      ...searchActions,
      push,
      notification
    })
    @withRouter
    class Search extends Component {
      static propTypes = {
        searchAll: PropTypes.func,
        search: PropTypes.object,
        push: PropTypes.func,
        notification: PropTypes.func,
        location: PropTypes.object,
        history: PropTypes.object,
        cancelSearch: PropTypes.func
      }

      unlisteners = []

      componentDidMount() {
        /**
         * Listen to route transitions and "cancel" if request is in progress and user
         * changes page. The reason == UX => search req. takes >30s on prod (SDNO-368)
         */
        const unlisten = this.props.history.listen(this.onRouteChanged)
        this.unlisteners.push(unlisten)
      }

      componentWillUnmount() {
        while (this.unlisteners.length) {
          const unlistener = this.unlisteners.pop()
          unlistener()
        }
      }

      onRouteChanged = () => {
        const { isLoading } = this.props.search
        if (isLoading) {
          // Cancels loading but the API request still might finish
          this.props.cancelSearch()
          this.props.notification(
            'Search was interrupted, you need to wait for the search to finish.',
            {
              intlKey: 'notifications.search_cancelled',
              status: 'info'
            }
          )
        }
      }

      handleSubmit = fields => {
        const { search } = this.props
        const query = get(fields, 'searchQuery')

        if (!query || search.isLoading) {
          return
        }

        this.handleSearch(query)
      }

      handleSearch = query => {
        this.props
          .searchAll(encodeURIComponent(query.trim()))
          .then(() => {
            const { search } = this.props
            if (!search.cancelled) {
              return this.props.push(`${appConfig.publicPath}/search`)
            }
          })
          .catch(err => {
            const userMessage = get(err, 'body.userMessage', false)

            this.props.notification(
              userMessage ||
              'There was an error while searching. Please try again later.',
              {
                intlKey: userMessage
                  ? undefined
                  : 'notifications.search_failed',
                status: 'error'
              }
            )

            console.error(err)
          })
      }

      render() {
        return (
          <ComposedComponent onSubmit={this.handleSubmit} {...this.props} />
        )
      }
    }
    return Search
  }
}

export default decorator
